"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MonthlySavingsPanel_1 = require("./MonthlySavingsPanel");
exports.default = MonthlySavingsPanel_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/MonthlySavingsPanel/index.js
// module id = 425
// module chunks = 8